import { useState } from "react";
import { currency } from "../../utils/number.utils";
import { CloseEyeIcon } from "../../utils/icon.utils";

export default function StockListForward({ company, price }) {
  const [hide, setHide] = useState(true);

  const toggle = () =>
    setHide((prev) => {
      setTimeout(() => {
        return setHide(true);
      }, 5000);
      return !prev;
    });

  const newPrice = hide ? <CloseEyeIcon /> : currency(price);

  return company === "Own" ? (
    company
  ) : (
    <div>
      <div>{company ?? "-"}</div>
      <div role="button" onClick={toggle}>
        {newPrice}
      </div>
    </div>
  );
}
